export enum ServiceStatusMessageTypes {
  ServiceStatusMessage = 1,
}
